import React, { useState, useEffect, Fragment } from 'react';
import { validateProperty, validate } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import { estatePackageCreationSchemaObject } from '../estatePackageCreationSchema';
import services from '../services';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import divisionService from '../../Devision/services';

const screenCode = 'ESTATEPACKAGE';

export function EstatePackageCreationAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add EstatePackage");
    const [groups, setGroups] = useState([]);
    const [buttonName, setButtonName] = useState("Save");
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionpoint, setCollectionpoint] = useState([]);
    const [users, setUsers] = useState([]);
    const [cards, setCards] = useState([]);
    const [userRemoveDropdown, setUserRemoveDropdown] = useState(false);
    const [isDropdownDisable, setIsDropdownDisable] = useState(false);
    const [userRemoveToggle, setUserRemoveToggle] = useState(false);
    const [editDisable, setEditDisable] = useState(false);
    const [isChanged, setIsChanged] = useState(0);
    const [estatePackageCreation, setEstatePackageCreation] = useState({
        packageID: '0',
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        aspNetUserId: '0',
        operationalCardID: '0',
        packageCode: '',
        backupLoginPassword: '',
        noOfSessions: '',
        packageName: '',
        isActive: true,
        removeUser: false,
        edit: props.location.edit !== undefined
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(estatePackageCreationSchemaObject).options({ allowUnknown: true });
    const [allowedOperationEntities, setAllowedOperationEntities] = useState([]);

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [estatePackageCreation]);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
        resetDropdowns();
    }, [estatePackageCreation.groupID]);

    useEffect(() => {
        trackPromise(
            getOperationCardForDropDown()
        )
    }, [estatePackageCreation.collectionPointID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointsAndUsersForDropDown()
        )
        resetOperationCardDropdown();
    }, [estatePackageCreation.operationEntityID]);


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITESTATEPACKAGE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });
        var token = tokenService.getUserDetailsFromTokenV2();
        setAllowedOperationEntities(token.operationEntities || []);
        if (data && edit) {
            setButtonName("Update");
            setTitle("Edit EstatePackage");
            setEstatePackageCreationEditData();
            setIsDropdownDisable(true);
            checkSessionStateByEstatePackageID();
        } else {
            setTitle("Add EstatePackage");
            setEstatePackageCreation({
                ...estatePackageCreation,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getGroupsForDropdown()
        )
    }

    function resetOperationCardDropdown() {
        if (!edit || (edit && isChanged >= 2)) {
            setCollectionpoint([]);
            setUsers([]);
            setCards([]);

            setEstatePackageCreation({
                ...estatePackageCreation,
                collectionPointID: "0",
                aspNetUserId: "0",
                operationalCardID: "0"
            });
        }
    }

    function resetDropdowns() {
        if (!edit || (edit && isChanged >= 2)) {
            setCollectionpoint([]);
            setUsers([]);
            setOperationEntity([]);
            setCards([]);

            setEstatePackageCreation({
                ...estatePackageCreation,
                collectionPointID: "0",
                aspNetUserId: "0",
                operationEntityID: "0",
                operationalCardID: "0"
            });
        }
    }

    function setEstatePackageCreationEditData() {

        if (data.aspNetUserId == null) {
            setUserRemoveDropdown(true);
        } else {
            setUserRemoveDropdown(false);
        }

        setEstatePackageCreation({
            ...estatePackageCreation,
            packageID: data.packageID,
            groupID: data.groupID.toString(),
            operationEntityID: data.operationEntityID.toString(),
            collectionPointID: data.collectionPointID.toString(),
            aspNetUserId: data.aspNetUserId === null ? "0" : data.aspNetUserId.toString(),
            operationalCardID: data.operationalCardID.toString(),
            packageCode: data.packageCode,
            packageName: data.packageName,
            backupLoginPassword: data.backupLoginPassword,
            noOfSessions: data.noOfSessions,
            createdBy: data.createdBy,
            createdDate: data.createdDate,
            isActive: data.isActive,
            removeUser: (data.aspNetUserId != 0 || data.aspNetUserId !== null)
        });
    }

    async function checkSessionStateByEstatePackageID() {

        const response = await services.editDataIfSOSTrue(data.packageID);
        if (response.data) {
            setEditDisable(response.data);
            setIsDropdownDisable(response.data);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
        }
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getEstatesByGroupID(estatePackageCreation.groupID);
        const allowedIDs = allowedOperationEntities.map(entity => entity.OperationEntityID);
        const filtered = Object.fromEntries(
            Object.entries(opEntities).filter(
                ([id, name]) => allowedIDs.includes(parseInt(id))
            )
        );
        setOperationEntity(filtered);
    }

    async function getCollectionPointsAndUsersForDropDown() {
        let collectionPonts;

        if (data && edit)
            collectionPonts = await services.GetAllCollectionPoints(estatePackageCreation.operationEntityID, estatePackageCreation.groupID);
        else
            collectionPonts = await services.GetCollectionPointForPackage(estatePackageCreation.operationEntityID, estatePackageCreation.groupID);

        setCollectionpoint(collectionPonts);

        const users = await services.getAvailableUsers(estatePackageCreation.operationEntityID, estatePackageCreation.aspNetUserId);
        setUsers(users);
    }

    async function getOperationCardForDropDown() {
        const opCards = await services.GetAllCardsByCollectionPointID(estatePackageCreation.collectionPointID, estatePackageCreation.operationalCardID);
        setCards(opCards);
    }

    function handleChange(e) {
        const target = e.target;

        if (target.name === "packageCode") {
            if (target.value.length === 3) return false;
        }

        const value = target.name === 'isActive' || target.name === 'removeUser' ? target.checked : target.value;
        if (target.name === 'removeUser' && target.checked === true) {
            setUserRemoveDropdown(false);
            setUserRemoveToggle(true);

            var filteredUsers = [];
            for (const item of Object.entries(users)) {
                filteredUsers[item[0]] = item[1];
            }

            setEstatePackageCreation({
                ...estatePackageCreation,
                aspNetUserId: "0",
                removeUser: true
            });
        }

        const error = { ...errors };
        const errorMessage = validateProperty(target, estatePackageCreationSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setEstatePackageCreation({
            ...estatePackageCreation,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function handleRemoveUser(e) {
        setUserRemoveToggle(false);

        var filteredUsers = [];
        for (const item of Object.entries(users)) {
            filteredUsers[item[0]] = item[1];
        }

        setEstatePackageCreation({
            ...estatePackageCreation,
            aspNetUserId: "0",
            removeUser: false,
        });
    }

    async function handleSave(e) {
        e.preventDefault();
        const errorMessages = validate(schema, estatePackageCreation);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        if (!edit) {
            const response = await services.saveEstatePackageCreation(estatePackageCreation);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        } else {
            const response = await services.editData(estatePackageCreation);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState();
            setTimeout(() => {
                props.history.push({ pathname: '/estatePackage' });
            }, 1500);
        }
    }

    function clearState() {
        setEstatePackageCreation({
            ...estatePackageCreation,
            groupID: '0',
            operationEntityID: '0',
            operationEntityTypeID: '0',
            collectionpointType: '0',
            collectionPointID: '0',
            aspNetUserId: '0',
            operationalCardID: '0',
            backupLoginPassword: '',
            packageCode: '',
            packageName: '',
            noOfSessions: '',
            isActive: true,
            removeUser: false
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/estatePackage"
                                    isChanged={isChanged}
                                    clearPage={clearState}
                                />
                            </div>
                            <hr />
                            <form onSubmit={(e) => handleSave(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            disabled={isDropdownDisable || !permissionList.isGroupFilterEnabled}
                                            id="groupID"
                                            name="groupID"
                                            value={estatePackageCreation.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            disabled={isDropdownDisable || !permissionList.isOperationEntityFilterEnabled}
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={estatePackageCreation.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col">
                                        <InputLabel shrink id="collectionPointID">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            disabled={isDropdownDisable}
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={estatePackageCreation.collectionPointID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(collectionpoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText error>{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col">
                                        <InputLabel shrink id="operationalCardID">Operation Card *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationalCardID"
                                            disabled={isDropdownDisable}
                                            id="operationalCardID"
                                            name="operationalCardID"
                                            value={estatePackageCreation.operationalCardID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Card--</MenuItem>
                                            {generateDropDownMenu(cards)}
                                        </Select>
                                        {errors["operationalCardID"] && <FormHelperText error>{errors["operationalCardID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <TextField fullWidth label="No Of Sessions *"
                                            name="noOfSessions"
                                            id="noOfSessions"
                                            disabled={editDisable}
                                            value={estatePackageCreation.noOfSessions}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["noOfSessions"] && <FormHelperText error>{errors["noOfSessions"]}</FormHelperText>}
                                    </div>
                                    <div className="col">
                                        <InputLabel shrink id="aspNetUserId">User *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="aspNetUserId"
                                            disabled={editDisable}
                                            id="aspNetUserId"
                                            name="aspNetUserId"
                                            value={estatePackageCreation.aspNetUserId}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select User--</MenuItem>
                                            {generateDropDownMenu(users)}
                                        </Select>
                                        {errors["aspNetUserId"] && <FormHelperText error>{errors["aspNetUserId"]}</FormHelperText>}
                                    </div>
                                    <div hidden={!edit}>
                                        <label>Remove User</label>
                                        <div className="form-group row">
                                            <div className="col-md pb-1">
                                                <input
                                                    disabled={userRemoveToggle}
                                                    className="mr-2"
                                                    id="removeUser"
                                                    switch="none"
                                                    //disabled={editDisable}
                                                    type="checkbox"
                                                    name="removeUser"
                                                    onChange={(e) => handleRemoveUser(e)}
                                                    checked={estatePackageCreation.removeUser}
                                                />
                                                <label htmlFor="removeUser" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <TextField fullWidth label="Package Code *"
                                            name="packageCode"
                                            id="packageCode"
                                            disabled={editDisable}
                                            value={estatePackageCreation.packageCode}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["packageCode"] && <FormHelperText error>{errors["packageCode"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <TextField fullWidth label="Package Name *"
                                            name="packageName"
                                            id="packageName"
                                            disabled={editDisable}
                                            value={estatePackageCreation.packageName}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["packageName"] && <FormHelperText error>{errors["packageName"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <TextField fullWidth label="Backup Login Password *"
                                            name="backupLoginPassword"
                                            id="backupLoginPassword"
                                            value={estatePackageCreation.backupLoginPassword}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["backupLoginPassword"] && <FormHelperText error>{errors["backupLoginPassword"]}</FormHelperText>}
                                    </div>
                                </div>
                                <label>Active</label>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            className="mr-2"
                                            id="isActive"
                                            disabled={editDisable}
                                            switch="none"
                                            type="checkbox"
                                            name="isActive"
                                            onChange={(e) => handleChange(e)}
                                            checked={estatePackageCreation.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, estatePackageCreation)}
                                        type="submit"
                                        className="btn btn-primary"
                                        //disabled={editDisable}
                                        value={buttonName}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        disabled={editDisable}
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );

}